// Import DataTables styles
import "datatables.net-dt/css/jquery.dataTables.css";

// Import DataTables JavaScript
import $ from "jquery";
import "datatables.net";

$(document).on("turbolinks:load", function () {
  if (document.getElementById("data_table_wrapper")) return;
  $("table#data_table").DataTable({
    "ordering": true,
      // drawCallback is necessary to make the archiving buttons work when changing table page
    "drawCallback": function (settings) {
      showArchiveDialog();
    }
  });
});

document.addEventListener("turbolinks:before-cache", function () {
  let dataTable = $("table#data_table").DataTable();
  if (dataTable !== null) {
    dataTable.destroy();
    dataTable = null;
  }
});

function showArchiveDialog() {
    const dialog = document.getElementById('archiveCommentDialog');
    const openButtons = document.querySelectorAll('.openDialogButton');
    const closeButton = document.getElementById('closeButton');
    const resourceIdSpan = document.getElementById('resourceId');
    const archiveLink = document.getElementById('archiveLink');
    const archiveLinkButton = document.getElementById('archiveLinkButton');
    const commentInput = document.getElementById('archivedComment');

    openButtons.forEach((button) => {
      button.addEventListener('click', () => {
        resourceIdSpan.textContent = button.getAttribute('data-resource-id');
        dialog.showModal();
      });
    });

    closeButton.addEventListener('click', () => {
      dialog.close();
    });

    commentInput.addEventListener('input', () => {
      if (commentInput.value.replace(/[^\p{L}]/gu,'') !== '') {
        archiveLink.classList.remove('disabled-no-comment');
        archiveLinkButton.classList.remove('disabled-no-comment');
      } else {
        archiveLink.classList.add('disabled-no-comment');
        archiveLinkButton.classList.add('disabled-no-comment');
      }
    })

    archiveLink.addEventListener('click', () => {
      const archivedComment = commentInput.value
      let controllerAction = location.pathname + '/' + resourceIdSpan.textContent + '/archive'
      if (archivedComment) {
        controllerAction += '?archived_comment=' + archivedComment
      }
      archiveLink.setAttribute('href', controllerAction)
    });
}